export const FAMB_SETTINGS_REPONSES = {
	GET_SETTINGS_ERROR:
		'Sorry, there was an error while retrieving your MortgageMatchup.com settings. Please try again later.',
	SAVE_SETTINGS_ERROR:
		'Sorry, there was an error while saving your MortgageMatchup.com settings. Please try again later.',
	URL_NOT_UNIQUE_ERROR:
		'This URL has already been taken. Please try a different URL.',
};

export const USER_PROFILE_RESPONSES = {
	VENDOR_LINK_SUCCESS:
		'You have successfully generated your personalized vendor project.',
	VENDOR_LINK_ERROR:
		'There was a problem with generating your web address from the vendor. Please check your information and try again.',
	VENDOR_LINK_SAVE_ERROR:
		'There was an issue updating your web address from the vendor. Please try again later.',
	PROFILE_SAVE_ERROR:
		'There was an issue saving your profile. Please review your information and try again or contact your admin.',
};

export const MODAL_TITLES = {
	VENDOR_LINK_TITLE: 'Generate Vendor Link',
	USER_PROFILE_SAVE_TITLE: 'Save User Profile',
};

export const CANCELLED_API_CALL = 'cancelled api call';
